// components/client-meta-tags.js
'use client';

import { usePageMeta } from "../src/updatePageMeta";

export function ClientMetaTags({ metaConfig }) {
    // This uses your custom hook to update meta tags when language changes
    usePageMeta(metaConfig);

    // This component doesn't render anything visible
    return null;
}
